import React from 'react';

const MAX_TEXT_LEN: number = 100;

interface PropsType {
    createStarted: boolean;
    welcomeMsg: string;
    updateWelcomeMsg: (msg: string) => void;
}

export class StepFour extends React.Component<PropsType> {

    constructor(props: PropsType) {
        super(props);
    }

    welcomeMsgAltered(inputText: string) {
        if (this.props.createStarted) return;
        let myInputText = inputText.replace(/[<>()\[\]\{\}\$]/g, "");
        this.props.updateWelcomeMsg(myInputText);
    }

    render() {
        return (
            <div className='teachers-taskcreater-step'>
                <hr />
                <h3>Step 4 - Optional</h3>
                <p>Enter a message to your students</p>
                <textarea rows={2} cols={50} className="teachers-taskcreater-longinput" placeholder='Welcome message...' value={this.props.welcomeMsg} onChange={(e) => this.welcomeMsgAltered(e.target.value)} maxLength={MAX_TEXT_LEN}></textarea>
            </div>
        )
    }
}
